import React from 'react';
import { Link } from '../Link.jsx';
import AuthorizedAction from '../AuthorizedAction.js';
import { getOrgSlug } from '../../lib/utils.js';

export const EmployeeLink = ({ employeeId, params, ...props }) => (
  <AuthorizedAction action="read" subject="employee">
    <Link
      route="employees/show"
      params={{ ...params, employeeId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EmployeeChangeImpactsLink = ({ employeeId, params, ...props }) => (
  <AuthorizedAction action="read" subject="employee">
    <Link
      route="employees/change-impacts"
      params={{ ...params, employeeId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EmployeeTasksLink = ({ employeeId, params, ...props }) => (
  <AuthorizedAction action="read" subject="employee">
    <Link
      route="employees/tasks"
      params={{ ...params, employeeId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EmployeeStakeholderProfilesLink = ({
  employeeId,
  params,
  ...props
}) => (
  <AuthorizedAction action="read" subject="employee">
    <Link
      route="employees/stakeholder-profiles"
      params={{ ...params, employeeId, slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);

export const EditEmployeesLink = ({ ...props }) => (
  <AuthorizedAction action="update" subject="employee">
    <Link
      route="organization/employees/edit"
      params={{ slug: getOrgSlug() }}
      {...props}
    />
  </AuthorizedAction>
);
